/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IPharmacySuppliers } from 'app/shared/model/pharmacy-suppliers.model';
import { IPharmacyStockBill } from 'app/shared/model/pharmacy-stock-bill.model';
import { IPharmacyReturnBill } from 'app/shared/model/pharmacy-return-bill.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { CreditType } from 'app/shared/model/enumerations/credit-type.model';
import { ClosureStatus } from 'app/shared/model/enumerations/closure-status.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';

export interface IPharmacyCredit {
  id?: string;
  totalAmount?: number;
  paidAmount?: number;
  pendingAmount?: number;
  creditType?: keyof typeof CreditType;
  addedById?: string | null;
  modifiedById?: string | null;
  closureStatus?: keyof typeof ClosureStatus;
  active?: boolean | null;
  cursor?: number | null;
  timestampentry?: number | null;
  microSec?: number | null;
  lastUpdated?: number | null;
  addedByType?: keyof typeof PharmacyAddedByType | null;
  modifiedByType?: keyof typeof PharmacyAddedByType | null;
  cancelledReason?: string | null;
  billNumber?: string | null;
  amended?: boolean | null;
  preGst?: boolean | null;
  pharmacy?: IPharmacy | null;
  supplier?: IPharmacySuppliers | null;
  purchasePayment?: IPharmacyStockBill | null;
  returnPayment?: IPharmacyReturnBill | null;
  amendedFrom?: IPharmacyCredit | null;
  amendedTo?: IPharmacyCredit | null;
  invoiceType?: IClinicalDictionary | null;
  urType?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IPharmacyCredit> = {
  active: false,
  amended: false,
  preGst: false,
};
